class IconFade extends HTMLElement {
    constructor() {
        super();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('show');
                entry.target.classList.remove('hide');
              }
            });
          });
          
          const iconItems = document.querySelectorAll('.icon-item');
          iconItems.forEach((el) => observer.observe(el));
    }
}

customElements.define('icon-fade', IconFade)